import React from 'react';
import classNames from 'classnames';

import * as Classes from '../common/classes';

interface Props extends React.HTMLAttributes<HTMLElement> {}

/**
 * Komponenta skupiny tagů.
 */
export const TagGroup: React.FC<Props> = ({
  className,
  children,
  ...restProps
}) => {
  const cls = classNames(Classes.TAG_GROUP, className);

  return (
    <div className={cls} {...restProps}>
      {children}
    </div>
  );
};
